export const isObject = (value: unknown): value is Record<string, any> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const toInlineString = (value: unknown): string => {
  if (value === null || value === undefined) {
    return '';
  }

  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }

  if (Array.isArray(value)) {
    if (value.every((item) => ['string', 'number', 'boolean'].includes(typeof item) || item === null)) {
      return value.map((item) => String(item ?? '')).join(', ');
    }

    return JSON.stringify(value);
  }

  if (isObject(value)) {
    return JSON.stringify(value);
  }

  return String(value);
};
